export const productSections = [
  {
    key: "all",
    title: "All Organic Products",
    subtitle:
      "Browse our complete range of natural Himalayan foods from Uttarakhand.",
    seoTitle:
      "Organic Products from Uttarakhand | Natural Food India | Ghar Ka Organic",
    seoDescription:
      "Shop organic pahadi products online including pickles, desi ghee, honey and spices. 100% natural, chemical-free, delivered across India.",
    seoKeywords:
      "organic food india, pahadi products online, uttarakhand natural food",
    badge: null,
    bannerDesktop: "/banners/gharka-pickle-1500x500.webp",
    bannerMobile: "/banners/gharka-pickle-1500x500.webp",
    chipImage: "/icons/categories/all.png",
  },

  {
    key: "new",
    title: "Most Loved Products",
    subtitle:
      "Best-selling natural, chemical-free products trusted by families across India.",
    seoTitle:
      "Best Organic Products in India | Best Selling Natural Food | Ghar Ka Organic",
    seoDescription:
      "Shop most loved organic food products from Uttarakhand including pahadi achar, desi ghee and raw honey. 100% natural and homemade.",
    seoKeywords:
      "best organic products india, natural food india, best selling organic food",
    badge: "Bestsellers",
    bannerDesktop: "/banners/bestsellers-1500x500.webp",
    bannerMobile: "/banners/bestsellers-mobile.webp",
    chipImage: "/icons/categories/bestseller.png",
  },

  {
    key: "honey",
    title: "Pure Pahadi Honey",
    subtitle:
      "Raw forest honey collected from Himalayan flowers, unprocessed and chemical-free.",
    seoTitle:
      "Buy Raw Honey Online | Pure Forest Honey India | Ghar Ka Organic",
    seoDescription:
      "Buy pure raw honey from Uttarakhand forests. Natural, unprocessed and rich in nutrients. Delivered across India.",
    seoKeywords:
      "buy raw honey online, forest honey india, natural honey uttarakhand",
    badge: "Pure & Raw",
    bannerDesktop: "/banners/honey-1500x500.webp",
    bannerMobile: "/banners/honey-mobile.webp",
    chipImage: "/icons/categories/honey.png",
  },

  {
    key: "ghee",
    title: "Pure Desi Cow Ghee",
    subtitle:
      "Traditional A2 cow ghee made using bilona method for authentic taste and nutrition.",
    seoTitle:
      "Buy Desi Ghee Online | A2 Bilona Ghee India | Ghar Ka Organic",
    seoDescription:
      "Buy pure desi cow ghee online made using traditional bilona method in Uttarakhand. 100% natural and rich in aroma.",
    seoKeywords:
      "buy desi ghee online, a2 bilona ghee india, pure cow ghee uttarakhand",
    badge: "Bilona Method",
    bannerDesktop: "/banners/ghee-1500x500.webp",
    bannerMobile: "/banners/ghee-mobile.webp",
    chipImage: "/icons/categories/ghee.png",
  },

  {
    key: "pickle",
    title: "Homemade Pahadi Pickles",
    subtitle:
      "Traditional Kumaoni pickles made using authentic recipes without preservatives.",
    seoTitle:
      "Buy Pahadi Achar Online | Homemade Pickles India | Ghar Ka Organic",
    seoDescription:
      "Buy homemade pahadi pickles from Uttarakhand. Traditional taste, no preservatives and fully natural ingredients.",
    seoKeywords:
      "buy pahadi achar online, homemade pickle india, uttarakhand mango pickle, nimbu-achar-online",
    badge: "No Preservatives",
    bannerDesktop: "/banners/pickle-1500x500.webp",
    bannerMobile: "/banners/pickle-mobile.webp",
    chipImage: "/icons/categories/pickle.png",
  },

  {
    key: "spices",
    title: "Fresh Pahadi Spices",
    subtitle:
      "Aromatic hand-ground spices from Uttarakhand for authentic Indian cooking.",
    seoTitle:
      "Buy Pahadi Spices Online | Natural Indian Masalas | Ghar Ka Organic",
    seoDescription:
      "Shop fresh pahadi spices and masalas from Uttarakhand. Naturally sourced and stone-ground for authentic taste.",
    seoKeywords:
      "buy pahadi spices online, indian masala online, natural spices india",
    badge: "Stone Ground",
    bannerDesktop: "/banners/spices-1500x500.webp",
    bannerMobile: "/banners/spices-mobile.webp",
    chipImage: "/icons/categories/spices.png",
  },

  {
    key: "pahadiSalts",
    title: "Pahadi Herbal Salts",
    subtitle:
      "Unique Himalayan salts infused with natural herbs and traditional minerals.",
    seoTitle:
      "Buy Herbal Salt Online | Himalayan Pahadi Salt India | Ghar Ka Organic",
    seoDescription:
      "Buy Himalayan herbal salts infused with natural minerals and traditional flavors from Uttarakhand.",
    seoKeywords:
      "buy himalayan salt india, herbal salt online, pahadi salt uttarakhand",
    badge: "Himalayan",
    bannerDesktop: "/banners/salts-1500x500.webp",
    bannerMobile: "/banners/salts-mobile.webp",
    chipImage: "/icons/categories/salt.png",
  },

  {
    key: "pahadiDals",
    title: "Organic Pahadi Dals",
    subtitle:
      "Nutritious and naturally grown pulses from Himalayan farms.",
    seoTitle:
      "Buy Organic Dal Online | Pahadi Pulses Uttarakhand | Ghar Ka Organic",
    seoDescription:
      "Shop organic pahadi dals and pulses grown in Uttarakhand hills. Healthy, chemical-free and rich in nutrition.",
    seoKeywords:
      "buy organic dal online, pahadi pulses uttarakhand, natural dal india",
    badge: "Chemical-Free",
    bannerDesktop: "/banners/dals-1500x500.webp",
    bannerMobile: "/banners/dals-mobile.webp",
    chipImage: "/icons/categories/dal.png",
  },

  {
    key: "chutney",
    title: "Instant Pahadi Chutney",
    subtitle:
      "Traditional Himalayan chutneys made from natural herbs, spices, and local ingredients.",
    seoTitle:
      "Buy Pahadi Chutney Online | Instant Himalayan Chutney | Ghar Ka Organic",
    seoDescription:
      "Order instant pahadi chutney from Uttarakhand. Made with natural herbs and spices, no preservatives and authentic mountain taste.",
    seoKeywords:
      "buy pahadi chutney online, himalayan chutney india, instant chutney natural",
    badge: "Traditional",
    bannerDesktop: "/banners/chutney-1500x500.webp",
    bannerMobile: "/banners/chutney-mobile.webp",
    chipImage: "/icons/categories/chutney.png",
  },
];